'use strict';

import i18next from 'i18next';
import loc_en from './locales/en/translations.json';
import loc_pt from './locales/pt/translations.json';

const i18nHandler = {
  keys: document.querySelectorAll('translate'),
  init(){
    const lang = window.location.pathname.replace(/\//g, '').replace(/marcocivil/g, '');
    const langfall = 'en';
    const location = window.location.pathname;

    if(location.indexOf('en') == -1 && location.indexOf('pt') == -1) {
      window.location = langfall;
    }

    i18next.init({
      debug: true,
      lng: lang,
      fallbackLng: langfall,
      ns: ['translations'],
      defaultNS: 'translations',
    }, (err, t) => {
      document.documentElement.lang = i18next.language;
      for(let index = 0; index < this.keys.length; index++) {
        let this_key = this.keys[index].innerText.toLowerCase();
        this.keys[index].dataset.key = this_key;
        this.keys[index].innerText = i18next.t(this_key)
      }

      // SETTING UP MENU
      // Elements
      let tracebackLinkIgarape = document.getElementById('traceback-link-igarape');
      let btnChangeLangEn = document.querySelectorAll('.menuChangeLanguageToEn');
      let btnChangeLangPt = document.querySelectorAll('.menuChangeLanguageToPt');
      let btnDownloadPDF = document.querySelectorAll('.menuDownloadPDF');
      let btnMailto = document.querySelectorAll('.menuMailto');
      let btnShareFacebook = document.querySelectorAll('.menuFacebookShare');
      let btnShareTwitter = document.querySelectorAll('.menuTwitterShare');
      let btnShareGooglePlus = document.querySelectorAll('.menuGooglePlusShare');
      let btnShareLinkedin = document.querySelectorAll('.menuLinkedinShare');

      // Values
      let igarapeLink = '#';
      let shareUrl = window.location;
      let shareUrlTwitter = '';
      let downloadPDF = '';
      let emailSubject = '';
      let shareTitle = '';
      let twitterUser = 'igarape_org';
      let twitterText = '';
      let linkedinSummary = '';
      let linkedinSource = '';

      if(i18next.language == 'en') {
        for(let index = 0; index < btnChangeLangEn.length; index++) {
          btnChangeLangEn[index].parentNode.style.display = 'none';
        }

        igarapeLink = 'https://igarape.org.br/en/';
        shareUrlTwitter = 'http://bit.ly/igarape-marcocivil-en';
        downloadPDF = 'assets/downloads/igarape_brazil-the-internet-and-the-digital-bill-of-rights.pdf';
        emailSubject = 'Reviewing the State of Brazilian Internet Governance';
        shareTitle = 'Brazil, the Internet and the Digital Bill of Rights';
        twitterText = 'Discover the achievements and weak points of Brazilian Digital Bill of Rights. By @ipolitico';
        linkedinSummary = 'What are the main achievements of brazilian Digital Bill of Rights? Is its legacy under risk? The latest publication of Igarapé Institute answers these questions and draws an overview of Brazilian Internet Governance.';
        linkedinSource = 'Igarapé Institute';
      } else if(i18next.language == 'pt') {
        for(let index = 0; index < btnChangeLangPt.length; index++) {
          btnChangeLangPt[index].parentNode.style.display = 'none';
        }

        igarapeLink = 'https://igarape.org.br/';
        shareUrlTwitter = 'http://bit.ly/igarape-marcocivil-pt';
        downloadPDF = 'assets/downloads/igarape_o-brasil-e-o-marco-civil-da-internet.pdf';
        emailSubject = 'O Brasil e o Marco Civil da Internet: uma análise completa';
        shareTitle = 'O Brasil e o Marco Civil da Internet';
        twitterText = 'Descubra as conquistas e fraquezas do Marco Civil da internet. Por @ipolitico';
        linkedinSummary = 'Quais os principais avanços e conquistas do Marco Civil da Internet? Seu legado está em risco? A nova publicação do Instituto Igarapé responde e traça um panorama sobre a governança digital brasileira.';
        linkedinSource = 'Instituto Igarapé';
      }

      tracebackLinkIgarape.href = igarapeLink;

      for(let index = 0; index < btnDownloadPDF.length; index++) {
        btnDownloadPDF[index].href = btnDownloadPDF[index].dataset.base + downloadPDF;
      }

      for(let index = 0; index < btnMailto.length; index++) {
        btnMailto[index].href = `mailto:teste@igarape.org.br?subject=${emailSubject}`;
      }

      // Facebook Share
      for(let index = 0; index < btnShareFacebook.length; index++) {
        btnShareFacebook[index].href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&t=${shareTitle}`;
        btnShareFacebook[index].onclick = function(){
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
          return false;
        };
      }

      // Twitter Share
      for(let index = 0; index < btnShareTwitter.length; index++) {
        btnShareTwitter[index].href = `https://twitter.com/share?url=${shareUrlTwitter}&via=${twitterUser}&text=${twitterText}`;
        btnShareTwitter[index].onclick = function(){
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
          return false;
        };
      }

      // Google Plus Share
      for(let index = 0; index < btnShareGooglePlus.length; index++) {
        btnShareGooglePlus[index].href = `https://plus.google.com/share?url=${shareUrl}`;
        btnShareGooglePlus[index].onclick = function(){
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=560,width=450');
          return false;
        };
      }

      // LinkedIn Share
      for(let index = 0; index < btnShareLinkedin.length; index++) {
        btnShareLinkedin[index].href = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${shareTitle}&summary=${linkedinSummary}&source=${linkedinSource}`;
        btnShareLinkedin[index].onclick = function(){
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
          return false;
        };
      }
    });

    // set json resources manually
    i18next.addResources('en', 'translations', loc_en);
    i18next.addResources('pt', 'translations', loc_pt);
  }
};

export default i18nHandler;
